import { useEffect } from "react";
import styles from "./medallia-survey.module.scss";

const medalliaScriptSrc: string = import.meta.env.VITE_MEDALLIA_EMBED_SCRIPT_SRC;

export const MedalliaSurvey = () => {
    useEffect(() => {
        if (!medalliaScriptSrc) return;
        if (document.querySelector(`script[src="${medalliaScriptSrc}"]`)) return;

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = medalliaScriptSrc;
        document.body.appendChild(script);

        return () => {
            script.remove();
        };
    }, []);

    return medalliaScriptSrc ? (
        <div id="FCEPrequalMedalliaSurvey" className={styles.medalliaSurveyRoot} />
    ) : /* istanbul ignore next */ null;
};
